import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  name: 'TeachingResourcesIndex',
  layout: 'default',
  head: {},
  jsonld() {
    // @ts-ignore
    console.log(this.title);
    // @ts-ignore
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
});

import { ref, onMounted, useContext, useMeta, useRoute } from '@nuxtjs/composition-api';
import { MetaInfo } from 'vue-meta';
import ResourcesList from '~/components/resource/ResourcesList.vue';
import Sliders from '~/components/resource/Sliders.vue';
import { navigationLinks } from '~/data/navigation_links_main';
import { Locale } from '~/types/locale';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const { i18n, $hrefLangsPage, $mzAnalyticsApi } = useContext();
const title = 'Teaching Resources';
const description =
  'Teaching Resources, Printables, Games, Activities & Worksheets | Teach Starter';
const regionalSchoolTerm = ref(i18n.locale === 'us' ? 'Elementary' : 'Primary');
const region = ref(i18n ? i18n.t('name') : null);
const $route = useRoute();

const videosParams = ref({
  country: i18n.locale,
  payload: 'basic',
  perPage: 6,
  types: ['video'],
});
const unitPlansParams = ref({
  country: i18n.locale,
  payload: 'basic',
  perPage: 6,
  types: ['unit-plan'],
});
const teachingResourcePacksParams = ref({
  country: i18n.locale,
  payload: 'basic',
  perPage: 6,
  types: ['resource-pack'],
});
const freeResourcesParams = ref({
  country: i18n.locale,
  payload: 'basic',
  perPage: 12,
  types: ['teaching-resource'],
  free: 1,
});

const latestResourcesParams = ref({
  country: i18n.locale,
  orderBy: 'created',
  order: 'desc',
  payload: 'basic',
  perPage: 12,
  types: ['teaching-resource'],
});
const yearLevels = ref(
  navigationLinks[i18n.locale as Locale] && navigationLinks[i18n.locale as Locale].year_levels
    ? navigationLinks[i18n.locale as Locale].year_levels
    : null
);
const resourceTypes = [
  {
    name: 'Free',
    link: '/resource-availability/free/',
  },
  {
    name: 'Worksheets',
    link: '/resource-type/worksheets/',
  },
  {
    name: 'Unit Plans',
    link: '/unit-plans/',
  },
  {
    name: 'Lesson Plans',
    link: '/lesson-plans/',
  },
  {
    name: 'Games',
    link: '/resource-type/games/',
  },
  {
    name: 'Craft Activities',
    link: '/resource-type/craft-activities/',
  },
  {
    name: 'Mindfulness',
    link: '/teaching-resource-collection/mindfulness/',
  },
];

const metaInfo: MetaInfo = {
  title,
  meta: [
    { hid: 'title', name: 'title', content: title },
    { hid: 'description', name: 'description', content: description },
  ],
  link: $hrefLangsPage($route.value),
};
useMeta(metaInfo);
onMounted(() => {
  $mzAnalyticsApi({
    event: 'pageView',
  });
});
expose({
  title,
});

return { __sfc: true,i18n, $hrefLangsPage, $mzAnalyticsApi, title, description, regionalSchoolTerm, region, $route, videosParams, unitPlansParams, teachingResourcePacksParams, freeResourcesParams, latestResourcesParams, yearLevels, resourceTypes, metaInfo, ResourcesList, Sliders }
}

})